import { useContext } from "react";

import { PortalConfigContext, type PortalConfigValue } from "@/portal/PortalConfigContext";

export function usePortalConfig(): PortalConfigValue {
  const ctx = useContext(PortalConfigContext);
  if (!ctx) {
    throw new Error("usePortalConfig must be used inside <PortalConfigProvider>");
  }
  return ctx;
}
